export default __webpack_public_path__ + "static/Sticker_A5_USERS_LT-257c6e11a9277b07ed4810174687b6a8.svg";